import React from 'react';
import { Select } from 'antd';
import noop from 'lodash.noop';
import SearchableSelector from './SearchableSelector';

const { Option } = Select;

const MinimalDrivers = ({
  minimalDrivers,
  value,
  onChange,
  style,
}: {
  minimalDrivers: any[];
  value?: any;
  onChange?: any;
  style?: React.CSSProperties;
}): JSX.Element => (
  <SearchableSelector
    loading={false}
    placeholder="Search to Select"
    value={value}
    onChange={onChange}
    width="100%"
    dropdownMatchSelectWidth={false}
    style={{ width: '100%', maxWidth: '100%', ...style }}
  >
    {(Array.isArray(minimalDrivers) ? minimalDrivers : []).map(({ fname, lname, licenseNumber }) => (
      <Option key={licenseNumber} value={licenseNumber}>
        {`${fname} ${lname} (${licenseNumber})`}
      </Option>
    ))}
  </SearchableSelector>
);

MinimalDrivers.defaultProps = {
  value: null,
  onChange: noop,
  style: {},
};

export default MinimalDrivers;
